import {Component} from '@angular/core';

@Component({
  template: ` <div fxFlexFill fxLayoutAlign="center center">
    <span class="mat-display-4">404</span>
    <span class="mat-headline">Not found.</span>
  </div>`,
})
export class NotFoundComponent {}
